interface IconProps {
  color?: string;
  opacity?: number;
}

const EmailVerifiedIcon = ({ color = "white", opacity = 1 }: IconProps) => (
  <svg
    width="120"
    height="120"
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <mask
      id="mask0_408_7787"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="120"
      height="120">
      <rect
        width="120"
        height="120"
        fill={color}
      />
    </mask>
    <g mask="url(#mask0_408_7787)">
      <path
        d="M77.4425 106.346L59.6538 88.5575L63.1925 85.0187L77.4425 99.2688L105.885 70.8275L109.423 74.365L77.4425 106.346ZM60 55L98.4613 30H21.5387L60 55ZM60 60.5775L20 34.4225V86.9225C20 87.82 20.2883 88.5575 20.865 89.135C21.4425 89.7117 22.18 90 23.0775 90H47L52 95H23.0775C20.7758 95 18.8542 94.2292 17.3125 92.6875C15.7708 91.1458 15 89.2242 15 86.9225V33.0775C15 30.7758 15.7708 28.8542 17.3125 27.3125C18.8542 25.7708 20.7758 25 23.0775 25H96.9225C99.2242 25 101.146 25.7708 102.688 27.3125C104.229 28.8542 105 30.7758 105 33.0775V57.7113L100 62.7113V34.4225L60 60.5775Z"
        fill={color}
        style={{ opacity: opacity }}
      />
    </g>
  </svg>
);

export default EmailVerifiedIcon;
